export default "__VITE_ASSET__DmW_AIVI__"